import React from 'react'
import Navbar from '../components/Navbar';
export default function Notfound() {
  return (
    <>
    <Navbar />
    <div>
      <img width="100%" height="600" src="https://kfg6bckb.media.zestyio.com/yalantis-interactive-404.gif" alt="" />
    </div>
   </>
  )
}
